import styled from 'styled-components';
import Colours from '/shared/styled/Colours';

export default styled.hr`
  border: 0;
  height: 1px;
  width: 100%;
  background: ${Colours.greyLight6};
  margin: 4rem 0;
`;
